import {
  Modal,
  Box,
  Text,
  Group,
  Grid,
  Select,
  TextInput,
  Button,
  NumberInput,
  MultiSelect,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { IconCalendarTime, IconChecklist, IconClockHour1, IconDeviceFloppy, IconFileText, IconMessageExclamation, IconPencilCheck, IconSearch, IconSettingsUp, IconUserCheck, IconUserCog } from "@tabler/icons-react";
import { crearEstadoInicialTarea, type IModalTareaVistaProps } from "../interfaces";
import { DateTimePicker } from "@mantine/dates";
import { MapaVista } from "../../../globales/componentes/mapa/mapaVista";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { obtenerZonaHorariaPorPais, obtenerNombrePaisPorId } from "../utils/zonaHorariaUtils";
import { EnumTipoTarea } from "../enums/enumTipoTarea";
import { EnumEstadoTarea } from "../enums/enumEstadoTarea";

dayjs.extend(utc);
dayjs.extend(timezone);


const ModalTareaVista: React.FunctionComponent<IModalTareaVistaProps> = ({
  abrir,
  guardarEditarTarea,
  manejarCambioValorTarea,
  abrirModalTarea,
  entidadesRegistro,
  agregarError,
  tareaSeleccionado,
  errores,
  consultarPorNumeroContrato,
  consultarPorCodigoEquipo,
  visualizacion
}) => {
  const [fechaActual, setFechaActual] = useState<Date>(new Date());

  useEffect(() => {
    // Actualizar fecha actual cada minuto
    const interval = setInterval(() => {
      setFechaActual(new Date());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    console.log("Tipo tarea cambio:", tareaSeleccionado.TipoServicioId)
  }, [tareaSeleccionado.TipoServicioId])

  const proyectoSeleccionado = entidadesRegistro.Proyectos.find(p => p.Id === tareaSeleccionado.ProyectoId);
  const timezoneProyecto = obtenerZonaHorariaPorPais(proyectoSeleccionado?.PaisId);
  const nombrePais = obtenerNombrePaisPorId(proyectoSeleccionado?.PaisId);



  return (
    <Modal
      closeOnClickOutside={false}
      opened={abrir}
      styles={{
        header: { backgroundColor: '#0074d914' }
      }}
      onClose={() => abrirModalTarea(false, crearEstadoInicialTarea())}
      title={<Text fw={500} fz="lg">
        {tareaSeleccionado.Id && visualizacion ? `Ver Tarea #${tareaSeleccionado.Id} - ${tareaSeleccionado.EstadoServicio?.Nombre}` : tareaSeleccionado.Id && !visualizacion ? `Editar Tarea #${tareaSeleccionado.Id} - ${tareaSeleccionado.EstadoServicio?.Nombre}` : "Agregar Tarea"}
      </Text>}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 1,
        zIndex: 100000,
      }}
      zIndex={100000}
      centered
      size={"90%"}
      radius="md"
      withCloseButton
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "60vh",
        }}>
        <Box
          p="md"
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: 'hidden',
          }}
        >
          <Grid gutter="sm">
            <Grid.Col span={{ base: 12, md: 3 }}>
              <Select
                leftSection={<IconFileText size={15} />}
                label="Proyecto"
                placeholder="Proyecto"
                searchable
                size="xs"
                required
                comboboxProps={{ zIndex: 1000000 }}
                data={entidadesRegistro.Proyectos.map(c => ({
                  value: c.Id.toString(),
                  label: c.Nombre,
                }))}
                nothingFoundMessage="No se encontraron proyectos"
                value={tareaSeleccionado.ProyectoId ? tareaSeleccionado.ProyectoId.toString() : null}
                clearable
                readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma ||
                  visualizacion}
                error={errores.ProyectoId}
                onChange={(value) => {
                  manejarCambioValorTarea("ProyectoId", value ? Number(value) : 0)
                  if (value === null) {
                    agregarError('ProyectoId', 'Selecciona un proyecto')
                  }
                  else {
                    agregarError('ProyectoId', '')
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <Select
                leftSection={<IconUserCheck size={15} />}
                label="Cliente"
                placeholder="Cliente"
                searchable
                size="xs"
                required
                readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma ||
                  visualizacion}
                comboboxProps={{ zIndex: 1000000 }}
                data={entidadesRegistro.Clientes.map(c => ({
                  value: c.Id.toString(),
                  label: c.Nombre,
                }))}
                nothingFoundMessage="No se encontraron clientes"
                value={tareaSeleccionado.ClienteId ? tareaSeleccionado.ClienteId.toString() : null}
                clearable
                error={errores.ClienteId}
                onChange={(value) => {
                  manejarCambioValorTarea("ClienteId", value ? value : 0)
                  if (value === null) {
                    agregarError('ClienteId', 'Selecciona un cliente')
                  }
                  else {
                    agregarError('ClienteId', '')
                  }
                }}
              />
            </Grid.Col>
            {entidadesRegistro.Equipos.length > 1 ? (
              <Grid.Col span={{ base: 12, md: 3 }}>
                <Select
                  label="Código Equipo"
                  placeholder="Código Equipo"
                  leftSection={<IconSettingsUp size={15} />}
                  searchable
                  size="xs"
                  required
                  comboboxProps={{ zIndex: 1000000 }}
                  data={entidadesRegistro.Equipos.map(c => ({
                    value: c.Id.toString(),
                    label: `${c.Codigo} - ${c.Nombre}`
                  }))}
                  nothingFoundMessage="No se encontraron equipos"
                  value={tareaSeleccionado.EquipoId ? tareaSeleccionado.EquipoId.toString() : null}
                  clearable
                  readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma ||
                    visualizacion}
                  error={errores.EquipoId}
                  onChange={(value) => {
                    const equipoId = value ? parseInt(value) : 0;
                    manejarCambioValorTarea("EquipoId", equipoId);

                    if (!value) {
                      agregarError('EquipoId', 'Selecciona un equipo');
                    } else {
                      agregarError('EquipoId', '');
                    }
                  }}
                />
              </Grid.Col>
            ) : (
              <Grid.Col span={{ base: 12, md: 3 }}>
                <TextInput
                  label="Código Equipo"
                  placeholder="Código Equipo"
                  size="xs"
                  rightSection={tareaSeleccionado.CodigoEquipo !== '' && !visualizacion ? <IconSearch cursor='pointer' onClick={() => consultarPorCodigoEquipo(tareaSeleccionado.CodigoEquipo)} size={14} /> : null}
                  maxLength={20}
                  readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                    tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma ||
                    visualizacion}
                  value={tareaSeleccionado.CodigoEquipo}
                  onChange={(e) => {
                    const value = e.currentTarget.value;
                    const regex = /^[A-Za-z0-9-]*$/;
                    if (regex.test(value)) {
                      manejarCambioValorTarea("CodigoEquipo", value);
                    }

                    if (!value) {
                      agregarError("EquipoId", "Este campo es requerido");
                    } else {
                      agregarError("EquipoId", "");
                    }
                  }}
                  description={tareaSeleccionado && tareaSeleccionado.Equipo && tareaSeleccionado.EquipoId ? tareaSeleccionado.Equipo.Nombre : ''}
                  inputWrapperOrder={['label', 'input', 'description', 'error']}
                  error={errores.EquipoId}
                  required
                />
              </Grid.Col>
            )}

            <Grid.Col span={{ base: 12, md: 3 }}>
              <TextInput
                label="Número Contrato"
                placeholder="Número Contrato"
                size="xs"
                rightSection={tareaSeleccionado.NumeroContrato !== '' && !
                  visualizacion ? <IconSearch cursor='pointer' onClick={() => consultarPorNumeroContrato(tareaSeleccionado.NumeroContrato)} size={14} /> : null}
                maxLength={20}
                value={tareaSeleccionado.NumeroContrato}
                onChange={(e) => {
                  const value = e.currentTarget.value;
                  const regex = /^[0-9.-]*$/;
                  if (regex.test(value)) {
                    manejarCambioValorTarea("NumeroContrato", value);
                  }

                  if (!value) {
                    agregarError("NumeroContrato", "Este campo es requerido");
                  } else {
                    agregarError("NumeroContrato", "");
                  }
                }}
                readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma ||
                  visualizacion}
                error={errores.NumeroContrato}
                required
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Tipo Tarea"
                placeholder="Tipo Tarea"
                size="xs"
                required
                comboboxProps={{ zIndex: 1000000 }}
                data={entidadesRegistro.TiposTarea.map(c => ({
                  value: c.Id.toString(),
                  label: c.Nombre,
                }))}
                nothingFoundMessage="No se encontraron tipos de tareas"
                value={tareaSeleccionado.TipoServicioId ? tareaSeleccionado.TipoServicioId.toString() : null}
                clearable
                readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma ||
                  visualizacion}
                error={errores.TipoServicioId}
                onChange={(value) => {
                  manejarCambioValorTarea("TipoServicioId", value ? Number(value) : 0)
                  // manejarCambioValorTarea("Tipo", value ? entidadesRegistro.TiposTarea.find(c => c.Id.toString() === value)?.Nombre || '' : '')
                  if (value === null) {
                    agregarError('TipoServicioId', 'Selecciona un tipo')
                  }
                  else {
                    agregarError('TipoServicioId', '')
                  }
                }}
              />

            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Técnico"
                placeholder="Técnico"
                searchable
                leftSection={<IconUserCog size={15} />}
                size="xs"
                required
                readOnly={(tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                  tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma) || (tareaSeleccionado.ProyectoId === 0 && tareaSeleccionado.EquipoId === 0) || visualizacion}
                comboboxProps={{ zIndex: 1000000 }}
                data={entidadesRegistro.Tecnicos.map(c => ({
                  value: c.Id.toString(),
                  label: c.NombreCompleto,
                }))}
                nothingFoundMessage="No se encontraron tecnicos"
                value={tareaSeleccionado.AsignadaA ? tareaSeleccionado.AsignadaA.toString() : null}
                clearable
                error={errores.AsignadaA}
                onChange={(value) => {
                  manejarCambioValorTarea("AsignadaA", value ? Number(value) : 0)
                  // manejarCambioValorTarea("Responsable", value ? entidadesRegistro.Tecnicos.find(c => c.Id.toString() === value)?.NombreCompleto || '' : '')
                  if (value === null) {
                    agregarError('AsignadaA', 'Selecciona un técnico')
                  }
                  else {
                    agregarError('AsignadaA', '')
                  }
                }}
              />

            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Grid gutter="sm">
                <Grid.Col span={{ base: 12, md: 12 }}>
                  <DateTimePicker
                    leftSection={<IconCalendarTime size={15} />}
                    label="Fecha Inicio Proyectada"
                    description={tareaSeleccionado.ProyectoId !== 0 ? `Validando según hora de ${nombrePais}` : undefined}
                    placeholder="Fecha Inicio Proyectada"
                    size="xs"
                    required
                    readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                      tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                      tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                      tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido || visualizacion}
                    disabled={tareaSeleccionado.ProyectoId === 0 || tareaSeleccionado.ClienteId === 0 || tareaSeleccionado.NumeroContrato === '' || visualizacion}
                    value={tareaSeleccionado.FechaInicio ? new Date(tareaSeleccionado.FechaInicio) : null}
                    defaultDate={tareaSeleccionado.FechaInicio ? new Date(tareaSeleccionado.FechaInicio) : undefined}
                    popoverProps={{ zIndex: 1000000 }}
                    excludeDate={(date) => {
                      const ahora = dayjs(fechaActual).tz(timezoneProyecto).startOf('day');
                      const esFechaDeTarea = tareaSeleccionado.FechaInicio
                        ? dayjs(date).isSame(dayjs(tareaSeleccionado.FechaInicio), 'day')
                        : false;
                      // Bloquear si es antes de hoy Y no es la fecha que ya tiene la tarea
                      return dayjs(date).isBefore(ahora, 'day') && !esFechaDeTarea;
                    }}
                    error={errores.FechaInicio}
                    onChange={(value) => {
                      if (!value) {
                        manejarCambioValorTarea("FechaInicio", "");
                        manejarCambioValorTarea("FechaFin", "");
                        return;
                      }

                      // Usar la hora del proyecto localmente
                      const fechaSeleccionada = dayjs(value);

                      const ahoraProyectoString = dayjs().tz(timezoneProyecto).format("YYYY-MM-DDTHH:mm:ss");
                      const ahoraProyecto = dayjs(ahoraProyectoString);
                      // Margen de 2 minutos para evitar falsos positivos por diferencias de reloj/zona horaria
                      const ahoraConMargen = ahoraProyecto.subtract(2, "minute");

                      const esHoy = fechaSeleccionada.isSame(ahoraProyecto, "day");

                      const esCreacion = !tareaSeleccionado.Id;

                      if (esCreacion && fechaSeleccionada.isBefore(ahoraProyecto, "day")) {
                        agregarError("FechaInicio", `La fecha de inicio debe ser mayor o igual a la fecha actual en ${nombrePais}`);
                        return;
                      }

                      else if (esCreacion && esHoy && fechaSeleccionada.isBefore(ahoraConMargen, "minute")) {
                        agregarError("FechaInicio", `La hora de inicio no puede ser anterior a la hora actual en ${nombrePais}`);
                        return;
                      }

                      else agregarError("FechaInicio", "");

                      const fechaInicio = fechaSeleccionada.format("YYYY-MM-DDTHH:mm:ss");
                      manejarCambioValorTarea("FechaInicio", fechaInicio);

                      // Recalcular Fecha Fin
                      if (tareaSeleccionado.Duracion) {
                        const fechaFin = fechaSeleccionada
                          .add(Number(tareaSeleccionado.Duracion), "minutes")
                          .format("YYYY-MM-DDTHH:mm:ss");

                        manejarCambioValorTarea("FechaFin", fechaFin);
                      } else {
                        manejarCambioValorTarea("FechaFin", "");
                      }
                    }}

                    timePickerProps={{
                      withDropdown: true,
                      popoverProps: { withinPortal: false },
                      format: '12h',
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <NumberInput
                    label="Duración (Minutos)"
                    size="xs"
                    min={0}
                    maxLength={4}
                    readOnly={(tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                      tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                      tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                      tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido) || !tareaSeleccionado.FechaInicio || visualizacion}
                    disabled={tareaSeleccionado.ProyectoId === 0 || tareaSeleccionado.ClienteId === 0 || tareaSeleccionado.NumeroContrato === '' || visualizacion}
                    leftSection={<IconClockHour1 size={17} />}
                    styles={{
                      label: { opacity: 1, color: "black", fontWeight: 500 } // 👀 forzamos visibilidad
                    }}
                    value={tareaSeleccionado.Duracion}
                    onChange={(value) => {
                      manejarCambioValorTarea("Duracion", value ?? 0);

                      if (!value) {
                        agregarError("Duracion", "Este campo es requerido");
                        manejarCambioValorTarea("FechaFin", "");
                        return;
                      }

                      agregarError("Duracion", "");

                      if (tareaSeleccionado.FechaInicio) {
                        const fechaFin = dayjs(tareaSeleccionado.FechaInicio)
                          .add(Number(value), "minutes")
                          .format("YYYY-MM-DDTHH:mm:ss");

                        manejarCambioValorTarea("FechaFin", fechaFin);
                      }
                    }}

                    error={errores.Duracion}
                    required
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <DateTimePicker
                    leftSection={<IconCalendarTime size={15} />}
                    label="Fecha Fin Proyectada"
                    placeholder="Fecha Fin Proyectada"
                    size="xs"
                    required
                    value={tareaSeleccionado.FechaFin}
                    popoverProps={{ zIndex: 1000000 }}
                    excludeDate={(date) => {
                      const ahora = dayjs(fechaActual).tz(timezoneProyecto).startOf('day');
                      const esFechaDeTarea = tareaSeleccionado.FechaFin
                        ? dayjs(date).isSame(dayjs(tareaSeleccionado.FechaFin), 'day')
                        : false;
                      return dayjs(date).isBefore(ahora, 'day') && !esFechaDeTarea;
                    }}
                    error={errores.FechaFin}
                    disabled
                    timePickerProps={{
                      withDropdown: true,
                      popoverProps: { withinPortal: false },
                      format: '12h',
                    }}
                  />
                </Grid.Col>
                {tareaSeleccionado.TipoServicioId === EnumTipoTarea.Emergencia && (
                  <Grid.Col span={{ base: 12, md: 6 }}>
                    <Select
                      label="Motivo Emergencia"
                      placeholder="Motivo Emergencia"
                      searchable
                      leftSection={<IconMessageExclamation size={15} />}
                      size="xs"
                      required
                      comboboxProps={{ zIndex: 1000000 }}
                      data={entidadesRegistro.CausalesEmergencia.map(c => ({
                        value: c.Id.toString(),
                        label: c.Nombre,
                      }))}
                      readOnly={tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                        tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                        tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                        tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                        tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma || visualizacion}
                      nothingFoundMessage="No se encontraron motivos"
                      value={tareaSeleccionado.CausalEmergenciaId ? tareaSeleccionado.CausalEmergenciaId.toString() : null}
                      clearable
                      error={errores.CausalEmergenciaId}
                      onChange={(value) => {
                        manejarCambioValorTarea("CausalEmergenciaId", value ? Number(value) : 0)
                        if (value === null && tareaSeleccionado.TipoServicioId === EnumTipoTarea.Emergencia) {
                          agregarError('CausalEmergenciaId', 'Selecciona una causal')
                        }
                        else {
                          agregarError('CausalEmergenciaId', '')
                        }
                      }}
                    />
                  </Grid.Col>
                )}
                <Grid.Col span={{ base: 12, md: 12 }}>
                  <MultiSelect
                    label="Modulos"
                    placeholder="Modulos"
                    name="ModulosChecklist"
                    required
                    data={entidadesRegistro.ModulosCheckList.map(mch => ({
                      value: mch.Id.toString(),
                      label: mch.Nombre,
                    }))}
                    disabled={
                      // tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Exitoso ||
                      // tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.EnCurso ||
                      // tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Cancelado ||
                      // tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.Fallido ||
                      // tareaSeleccionado.EstadoTareaId === EnumEstadoTarea.PendienteFirma ||
                      tareaSeleccionado.EquipoId === 0 || tareaSeleccionado.TipoServicioId === null || tareaSeleccionado.TipoServicioId === undefined || tareaSeleccionado.TipoServicioId === 0}
                    error={errores.ModulosChecklist}
                    readOnly={tareaSeleccionado.TipoServicioId === EnumTipoTarea.Emergencia || tareaSeleccionado.TipoServicioId === EnumTipoTarea.Correctivo || tareaSeleccionado.TipoServicioId === EnumTipoTarea.Acompanamiento || visualizacion}
                    comboboxProps={{ zIndex: 1000000 }}
                    value={tareaSeleccionado.ModulosChecklist ? tareaSeleccionado.ModulosChecklist.map(t => t.toString()) : []}
                    nothingFoundMessage="No se encontraron modulos"
                    size="xs"
                    onChange={(valores) => {
                      manejarCambioValorTarea('ModulosChecklist', valores.map(v => Number(v)));

                      if (valores.length === 0 && tareaSeleccionado.TipoServicioId !== EnumTipoTarea.Emergencia && tareaSeleccionado.TipoServicioId !== EnumTipoTarea.Correctivo && tareaSeleccionado.TipoServicioId !== EnumTipoTarea.Acompanamiento) {
                        agregarError('ModulosChecklist', 'Selecciona minimo un modulo')
                      }
                      else {
                        agregarError('ModulosChecklist', '')
                      }
                    }}
                    leftSection={<IconChecklist size={17} />}
                    searchable
                  />
                </Grid.Col>
              </Grid>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }} style={{ zIndex: 10, display: 'flex', alignItems: 'center' }}>
              <MapaVista
                latitud={Number(entidadesRegistro.Proyectos.find(p => p.Id === tareaSeleccionado.ProyectoId)?.Latitud)}
                longitud={Number(entidadesRegistro.Proyectos.find(p => p.Id === tareaSeleccionado.ProyectoId)?.Longitud)}
                popupText={entidadesRegistro.Proyectos.find(p => p.Id === tareaSeleccionado.ProyectoId)?.Direccion || ''}
                height="180px" />
            </Grid.Col>
          </Grid>
        </Box>
        <Box
          style={{
            backgroundColor: "#fff",
          }}
        >
          <Group justify="flex-end">
            <Button
              onClick={guardarEditarTarea}
              color="primary"
              variant="filled"
              size='compact-sm'
              radius="lg"
              disabled={visualizacion}
              rightSection={tareaSeleccionado.Id ? <IconPencilCheck opacity={100} color="white" size={15} /> : <IconDeviceFloppy opacity={100} color="white" size={15} />}
            >
              <Text fw={500} fz={11}>{tareaSeleccionado.Id ? "Editar Tarea" : "Guardar Tarea"}</Text>
            </Button>


          </Group>
        </Box>
      </Box>

    </Modal >
  );
};

export default ModalTareaVista;
